(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-login"]) return;
  try {
    
window.document.onload = (event) => {
  if (window.location.href.includes('#recover')) {
    const event = new CustomEvent('dialog:trigger:recover');
    document.dispatchEvent(event);
  }
}

  } catch(e) { console.error(e); }
})();
})();
